<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :has-buttons="false"
    :disabled="true"
    :moduleEnabler="moduleEnabler"
  />
</template>
<script>
import { get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'ParcelReportSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules.PARCELS_REPORT.verbose_name'),
    moduleEnabler() {
      return {
        name: 'parcel_report_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
